const { SPACE } = require('../helpers');

const states = {
  B: 'Beni',
  H: 'Sucre',
  C: 'Cochabamba',
  L: 'La Paz',
  O: 'Oruro',
  N: 'Cobija',
  P: 'Potosí',
  S: 'Santa Cruz',
  T: 'Tarija'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.countryDefinition = {
  country: 'Bolivia',
  code: 'BO',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'District',
      width: 0.5
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'stateCode']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city', 'stateCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' }
  ]
};
